"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bindingScopeValues = void 0;
exports.bindingScopeValues = {
    Request: 'Request',
    Singleton: 'Singleton',
    Transient: 'Transient',
};
//# sourceMappingURL=BindingScope.js.map